<template>
  <div class="modal fade" id="harvest-plant" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="modal-block-vcenter" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="block block-themed block-transparent mb-0">
          <div class="block-header" :class="[headerColor]">
            <h3 class="block-title"><i class="fa fa-cut"></i> {{ titleLabel }}</h3>
            <div class="block-options">
              <button type="button" class="btn-block-option" data-dismiss="modal" aria-label="Close" @click.prevent="clearData()">
                <i class="fa fa-fw fa-times"></i>
              </button>
            </div>
          </div>
          <transition name="slide-fade">
            <div class="text-center alert-message-top" v-if="errorMsg">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="alert-message alert-danger alert-error-message">{{ errorMsg }}</div>
              </div>
            </div>
          </transition>
          <div class="block-content">
            <div class="form-group">
              <label>Plant Label</label>
              <input v-model="plantLabel" name="plantLabel" type="text" class="form-control form-control-alt" placeholder="Plant Label" />
            </div>
            <div class="form-group required">
              <label class="control-label">Weight</label>
              <input v-model="weight" name="weight" type="text" v-validate="'required'" data-vv-as="Weight" class="form-control form-control-alt" placeholder="Weight" />
              <p v-if="errors.has('weight')" class="errorMsg">{{ errors.first('weight') }}</p>
            </div>
            <div class="form-group required">
              <label class="control-label">Unit Of Weight</label>
              <select name="harvest-plant-unit" class="form-control form-control-alt v-plant-select2-dropdown" placeholder="Select Unit of weight.." style="width: 100%">
                <option></option>
                <option :value="unit.Name" v-for="(unit, index) in library.unitOfMeasurement" :key="index">{{ unit.Name }}</option>
              </select>
              <p v-if="unitError" class="errorMsg">The Unit of weight field is required.</p>
            </div>
            <div class="form-group">
              <label>Harvest Name</label>
              <input v-model="harvestName" type="text" class="form-control form-control-alt" placeholder="Harvest Name" />
            </div>
            <div class="form-group required">
              <label class="control-label">Drying Room</label>
              <select name="harvest-plant-room" class="form-control form-control-alt v-plant-select2-dropdown" placeholder="Select Room.." style="width: 100%">
                <option></option>
                <option :value="room.Name" v-for="(room, index) in library.rooms" :key="index">{{ room.Name }}</option>
              </select>
              <p v-if="roomError" class="errorMsg">The Drying Room field is required.</p>
            </div>
            <div class="form-group">
              <label>Date</label>
              <input v-model="actualDate" id="harvest-datepicker" type="text" class="form-control form-control-alt" placeholder="Add New Tag" />
            </div>
          </div>
          <div class="block-content block-content-full text-right border-top button-loader">
            <button type="button" class="btn btn-sm btn-light" data-dismiss="modal" @click.prevent="clearData()">Close</button>
            <button type="button" class="btn btn-sm btn-primary" @click.prevent="harvestPlant()" :bind:disabled="showModalLoader">
              <div><i class="fa fa-save mr-1"></i>Save</div>
              <span class="modal-loader" v-if="showModalLoader">
                <hash-loader class="custom-class text-white" color="#fff" loading="loading" size="15" sizeUnit="px"></hash-loader>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import { mapState, mapActions } from 'vuex';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
import { helper } from '@/helper.js';
import $ from 'jquery';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css';
Vue.use(VeeValidate, VueSpinners);

export default {
  name: 'HarvestPlant',
  data() {
    return {
      plantLabel: '',
      weight: '',
      unitOfWeight: '',
      dryingRoom: '',
      harvestName: '',
      actualDate: new Date().toJSON().slice(0,10),
      roomError: false,
      unitError: false,
      errorMsg: '',
      showModalLoader: false,
      headerColor: 'bg-info',
      action: 'harvestplants',
      titleLabel: ''
    };
  },
  components: {
    HashLoader
  },
  computed: {
    ...mapState({
      library: state => state.library
    })
  },
  mounted() {
    let vm = this;
    $('select[name="harvest-plant-room"]').on('change', function() {
      vm.dryingRoom = $(this).val(); vm.roomError = false;
    });
    $('select[name="harvest-plant-unit"]').on('change', function() {
      vm.unitOfWeight = $(this).val(); vm.unitError = false;
    });
    let datePicker = $('#harvest-datepicker').datepicker(
      { format: 'yyyy-mm-dd', autoclose: true }
    );
    datePicker.on('changeDate', (e) => {
      vm.actualDate = e.format();
    });
  },
  methods: {
    ...mapActions('library', ['getAllHarvests']),
    clearData() {
      this.plantLabel = '';
      this.weight = '';
      this.unitOfWeight = '';
      this.dryingRoom = '';
      this.harvestName = '';
      this.unitError = '';
      this.roomError = '';
      this.actualDate = new Date().toJSON().slice(0,10);
      $('.v-plant-select2-dropdown').val(null).trigger('change');
      $('#harvest-plant-room').datepicker('update', this.date);
      this.action = '';
      this.titleLabel = '';
      this.$validator.reset();
    },
    setPlantLabel(label, bgColor, action) {
      this.plantLabel = label;
      this.headerColor = bgColor;
      this.action = action;
      this.titleLabel = 'Manicure Plant';
      if (this.action === 'harvestplants') {
        this.titleLabel = 'Harvest Plant';
      }
    },
    harvestPlant() {
      let vm = this;
      this.$validator.validate().then(valid => {
        if (vm.validate() && valid) {
          vm.showModalLoader = true;
          vm.errorMsg = '';
          helper.sendPostRequest(
            '/plants/' + vm.action,
            {
              Plant: this.plantLabel,
              Weight: this.weight,
              UnitOfWeight: this.unitOfWeight,
              DryingRoom: this.dryingRoom,
              HarvestName: this.harvestName,
              ActualDate: this.actualDate
            }
          ).then((data) => {
            if (data.status === 'success') {
              vm.showModalLoader = false;
              vm.getAllHarvests();
              jQuery('#harvest-plant').modal('hide');
              vm.clearData();
              helper.showSuccessModal(data.message);
            } else {
              vm.errorMsg = data.message;
              vm.showModalLoader = false;
            }
          });
        }
      });
    },
    validate() {
      if (this.unitOfWeight === '') {
        this.unitError = true;
      }

      if (this.dryingRoom === '') {
        this.roomError = true;
      }

      if (this.unitError || this.roomError) {
        return false;
      }
      return true;
    }
  }
};
</script>


// WEBPACK FOOTER //
// source/components/modals/HarvestPlant.vue